// app.js
import React, { useEffect } from "react";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/header";
import ArtCulture from "./components/Artculture"; // Fixed component case matching export
import Home from "./screen/home";
import Facility from "./screen/facility";
import Hero from "./screen/hero";
import Program from "./screen/program";
import Appoitment from "./screen/appoitment";
import Footer from "./components/footer";
// import Teacher from "./screen/teacher";
import Imagecard from "./screen/imagecard";
import Imageeffect from "./screen/imageeffect";
import Contact from "./screen/contect";
import Blog from "./screen/Blog";
import Blog1 from "./screen/blog1";
import Blog2 from "./screen/blog2";
import Blog3 from "./screen/blog3";
import Blog4 from "./screen/blog4";
import Blog5 from "./screen/blog5";
import Blog6 from "./screen/blog6";
import Blog7 from "./screen/blog7";
import Blog8 from "./screen/blog8";
import Blog9 from "./screen/blog9";
import Blog10 from "./screen/blog10";
import Blog11 from "./screen/blog11";
import Blog12 from "./screen/blog12";
import Blog13 from "./screen/blog13";
import Blog14 from "./screen/blog14";
import Blog15 from "./screen/blog15";
import Blog16 from "./screen/blog16";
import Blog17 from "./screen/blog17";
import Blog18 from "./screen/blog18";
import Blog19 from "./screen/blog19";
import Blog20 from "./screen/blog20";
import Blog21 from "./screen/blog21";
import Blog22 from "./screen/blog22";
import Blog23 from "./screen/blog23";
import Blog24 from "./screen/blog24";
import Blog25 from "./screen/blog25";
import Blog26 from "./screen/blog26";
import Blog27 from "./screen/blog27";
import Blog28 from "./screen/blog28";
import Blog29 from "./screen/blog29";
import Blog30 from "./screen/blog30";
import Blog31 from "./screen/blog31";
import Blog32 from "./screen/blog32";
import Blog33 from "./screen/blog33";
import Blog34 from "./screen/blog34";
import Blog35 from "./screen/blog35";
import Blog36 from "./screen/blog36";
import Blog37 from "./screen/blog37";
import Blog38 from "./screen/blog38";
import Blog39 from "./screen/blog39";
import Blog40 from "./screen/blog40";
import Blog41 from "./screen/blog41";
import Blog42 from "./screen/blog42";
import Blog43 from "./screen/blog43";
import Blog44 from "./screen/blog44";
import Blog45 from "./screen/blog45";
import Blog46 from "./screen/blog46";

import SanityBlog from "./screen/SanityBlog";

/** Scroll to top on route change (supports #hash anchors) */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If URL has a hash, try to scroll to that element
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    // Otherwise scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      {/* Scroll to top on every navigation */}
      <ScrollToTop />

      <Routes>
        {/* Hardcoded Blog Entries */}
        <Route path="/blog/RedHouseSchoolVadodara–BestPlay-BasedPreschool" element={<Blog1 />} />
        <Route path="/blog/Short_Moral_Stories_for_Kids_in_English" element={<Blog2 />} />
        <Route path="/blog/What_Is_an_Educational_Environment_and_Why_It_Matters_for_Your_Child’s_Growth" element={<Blog3 />} />
        <Route path="/blog/The_Impact_of_Technology_in_Education" element={<Blog4 />} />
        <Route path="/blog/Why_Red_House_School_is_the_Best_School_in_Vadodara" element={<Blog5 />} />
        <Route path="/blog/A_Promise_for_Life_Fostering_Sibling_Bonds_This_Raksha_Bandhan" element={<Blog6 />} />
        <Route path="/blog/Why_Holistic_Education_Matters_–_The_Red_House_Approach" element={<Blog7 />} />
        <Route path="/blog/choosing_the_best_preschool_in_vadodara" element={<Blog8 />} />
        <Route path="/blog/Home_to_School:Road_Safety_Tips_for_Children|_Red_School_House_Vadodara" element={<Blog9 />} />
        <Route path="/blog/Lighting_Up_Diwali:Exploring_Traditions_and_Art_with_Preschoolers|_Red_School_House_Vadodara" element={<Blog10 />} />
        <Route path="/blog/How_AI_is_Changing_the_World_of_Learning" element={<Blog11 />} />
        <Route path="/blog/Why_Family_Matters:The_Role_of_Loved_Ones_in_Shaping_Our_Lives|_Red_School_House_Vadodara" element={<Blog12 />} />
        <Route path="/blog/The_reason_why_quality_preschools_are_on_the_rise_among_the_working_parents_in_India" element={<Blog13 />} />
        <Route path="/blog/The_Power_of_Play:_Nurturing_Growth_in_Vadodara's_Happiest_Preschool" element={<Blog14 />} />
        <Route path="/blog/Choosing_the_Right_Preschool_in_Vadodara:_A_Checklist_for_Parents" element={<Blog15 />} />
        <Route path="/blog/Why_a_Low_Teacher-Student_Ratio_Is_a_Key_to_Finding_the_Best_Preschool_in_Vadodara" element={<Blog16 />} />
        <Route path="/blog/10_Best_Diwali_Celebration_Ideas_for_Schools_in_2025" element={<Blog17 />} />
        <Route path="/blog/Creating_a_Joyful_Start_to_Every_Childs_Learning_Journey" element={<Blog18 />} />
        <Route path="/blog/Early_Childhood_Education_in_Vadodara:_Why_the_Right_Start_Matters_Most" element={<Blog19 />} />
        <Route path="/blog/How_Red_School_House_Encourages_Creativity_and_Confidence_in_Young_Learners" element={<Blog20 />} />
        <Route path="/blog/Top_Qualities_Every_Parent_Should_Look_for_in_a_Preschool" element={<Blog21 />} />
        <Route path="/blog/The_Role_of_Teachers_in_Shaping_Early_Childhood_Learning" element={<Blog22 />} />
        <Route path="/blog/Parent_Involvement_in_Preschool" element={<Blog23 />} />
        <Route path="/blog/Why_Emotional_Intelligence_Begins_in_Preschool" element={<Blog24 />} />
        <Route path="/blog/How_Red_School_House_Blends_Fun_and_Learning_for_Kindergarten_Success" element={<Blog25 />} />
        <Route path="/blog/Developing_Social_Skills_in_Early_Years_Red_School_Houses_Proven_Approach" element={<Blog26 />} />
        <Route path="/blog/Celebrating_Animal_Themes_Teaching_Values_Through_Joyful_Learning" element={<Blog27 />} />
        <Route path="/blog/The_Importance_of_a_Safe_and_Nurturing_Preschool_Environment" element={<Blog28 />} />
        <Route path="/blog/Why_Mid-Career_Professionals_Are_Choosing_the_Preschool_Franchise_Path" element={<Blog29 />} />
        <Route path="/blog/Winter_Morning_Routine_for_Preschoolers_A_Cozy_Start_to_the_Day" element={<Blog30 />} />
        <Route path="/blog/How_Preschool_Activities_Spark_a_Love_for_Learning_in_Young_Minds" element={<Blog31 />} />
        <Route path="/blog/How_Art_and_Music_Enhance_Child_Development" element={<Blog32 />} />
        <Route path="/blog/Top_Reasons_Parents_Choose_Red_School_House_Vadodara_for_Preschool_Education" element={<Blog33 />} />
        <Route path="/blog/How_Sensory_Play_Shapes_Brain_Development_in_Preschoolers" element={<Blog34 />} />
        <Route path="/blog/The_Science_Behind_Play_Why_Children_Learn_Best_Through_Fun" element={<Blog35 />} />
        <Route path="/blog/Best_Christmas_Poems_for_Kids" element={<Blog36 />} />
        <Route path="/blog/The_Importance_of_Hygiene_Habits_for_Preschool_Children" element={<Blog37 />} />
        <Route path="/blog/Why_Nutrition_Matters_in_Early_Childhood_Development" element={<Blog38 />} />
        <Route path="/blog/Helping_Shy_Kids_Become_More_Confident_in_Preschool" element={<Blog39 />} />
        <Route path="/blog/The_Role_of_Preschool_in_Building_Emotional_Strength" element={<Blog40 />} />
        <Route path="/blog/Creativity_in_the_Classroom_Why_It_Matters" element={<Blog41 />} />
        <Route path="/blog/How_Preschools_Shape_Values_in_Early_Childhood" element={<Blog42 />} />
        <Route path="/blog/How_Safe_Classrooms_Encourage_Better_Learning_Outcomes" element={<Blog43 />} />
        <Route path="/blog/Boosting_Early_Learning_Through_Hands-On_Activities" element={<Blog44 />} />
        <Route path="/blog/10_Questions_Every_Parent_Must_Ask_Before_Choosing_a_Preschool" element={<Blog45 />} />
        <Route path="/blog/The_Benefits_of_Peer_Learning_in_Preschool" element={<Blog46 />} />

        {/* Core Pages & Clean Blog Overviews */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<SanityBlog />} /> {/* Dynamic route placed cleanly after exact paths */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/Artculture" element={<ArtCulture />} /> {/* Updated JSX Target to match fixed import */}
        <Route path="/imageeffect" element={<Imageeffect />} />
        <Route path="/imagecard" element={<Imagecard />} />
        {/* <Route path="/teacher" element={<Teacher />} /> */}
        <Route path="/appotment" element={<Appoitment />} />
        <Route path="/program" element={<Program />} />
        <Route path="/hero" element={<Hero />} />
        <Route path="/facility" element={<Facility />} />
        <Route path="/" element={<Home />} />
        <Route path="header" element={<Header />} />
        <Route path="footer" element={<Footer />} />
      </Routes>
    </BrowserRouter>
  );
}
